import { type UserDocument } from '@hooks/use-ocr.hooks.ts'
import React, { type ReactNode } from 'react'

type ContainerProps = DocumentContainerProps & {
	children: (document: DocumentCard) => ReactNode
}
const Container: React.FC<ContainerProps> = ({
	children,
	documents,
	source,
}) => (
	<>
		{documents.map(
			(document) =>
				!source.includes(document.id) && (
					<React.Fragment key={document.id}>
						{children(document)}
					</React.Fragment>
				)
		)}
	</>
)

type DocumentCard = {
	title: string
	id: UserDocument
}
type DocumentContainerProps = {
	documents: Array<DocumentCard>
	source: Array<UserDocument>
}
export const DocumentContainer: React.FC<DocumentContainerProps> = (props) => (
	<section
		className='documents__container'
		style={{
			gridTemplateColumns: `repeat(${Math.abs(
				props.documents.length - props.source.length
			)}, 1fr)`,
		}}
	>
		<DocumentsImage {...props} />
		<DocumentsTitle {...props} />
	</section>
)

const DocumentsImage: React.FC<DocumentContainerProps> = (props) => (
	<Container {...props}>
		{(document) => (
			<img
				src={`/assets/images/${document.id}.svg`}
				alt={document.id}
				height={80}
			/>
		)}
	</Container>
)

const DocumentsTitle: React.FC<DocumentContainerProps> = (props) => (
	<Container {...props}>
		{(document) => <p className='document-card__title'>{document.title}</p>}
	</Container>
)
